import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { ChannelTypeTag } from './ChannelTypeTag';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const MigrationMessagingBannerWithConversationsAlert = ({
  name,
  onClose,
  type,
  viewStatusRoute
}) => {
  return /*#__PURE__*/_jsx(Alert, {
    type: "info",
    titleText: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "svh-conversations-settings-lib.migration.messagingBanner.titleWithConversations_jsx",
      elements: {
        ChannelTypeTag
      },
      options: {
        name,
        type
      }
    }),
    closeable: true,
    onClose: onClose,
    children: viewStatusRoute ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: {
        Link
      },
      message: "svh-conversations-settings-lib.migration.messagingBanner.message_jsx",
      options: {
        href: viewStatusRoute
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "svh-conversations-settings-lib.migration.messagingBanner.message"
    })
  });
};
MigrationMessagingBannerWithConversationsAlert.displayName = 'MigrationMessagingBannerWithConversationsAlert';
export default MigrationMessagingBannerWithConversationsAlert;